import React, { ReactElement } from "react";
import DeliveryReportList from "../../components/Finance/DeliveryReport";
import Layout from "../../components/layout";

const DeliveryReportPage = (): ReactElement => {
  return (
    <Layout>
      <DeliveryReportList />
    </Layout>
  );
};

export default DeliveryReportPage;
